import { HFBox, HFButton } from '@hf/designSystem/v1';
import { ANALYTICS_CONSENT_DETAIL } from './consent';

const TITLE_ID = 'hf-cookie-consent-title';
const DESC_ID = 'hf-cookie-consent-desc';

export function CookieConsentModal({ open, onAccept, onDecline }: { open: boolean; onAccept: () => void; onDecline: () => void }) {
  if (!open) return null;
  return (
    <HFBox
      component="aside"
      role="region"
      aria-labelledby={TITLE_ID}
      aria-describedby={DESC_ID}
      data-nosnippet=""
      sx={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        zIndex: (theme) => theme.zIndex.snackbar,
        transform: 'translateX(-50%)',
        width: 'min(880px, calc(100vw - 32px))',
        p: 1.5,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 1.5,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: 'background.paper',
        color: 'text.secondary',
        boxShadow: 8,
        fontSize: 13,
        lineHeight: 1.45,
      }}
    >
      <HFBox sx={{ flex: '1 1 220px', minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <HFBox
          id={TITLE_ID}
          component="h2"
          sx={{ m: 0, color: 'text.primary', fontSize: 11, fontWeight: 800, letterSpacing: '0.09em', textTransform: 'uppercase' }}
        >
          Cookies
        </HFBox>
        <HFBox id={DESC_ID} component="p" sx={{ m: 0 }}>
          {ANALYTICS_CONSENT_DETAIL}
        </HFBox>
      </HFBox>
      <HFBox sx={{ display: 'flex', flexShrink: 0, gap: 1, ml: 'auto' }}>
        <HFButton size="small" variant="outlined" onClick={onDecline}>
          Decline
        </HFButton>
        <HFButton size="small" variant="contained" onClick={onAccept}>
          Accept
        </HFButton>
      </HFBox>
    </HFBox>
  );
}
